import { jsx as _jsx } from "react/jsx-runtime";
import { Chip, Stack } from '@mui/material';
const splitSeparator = '&#8226;';
const SuggestedPrompts = ({ append, isLoading, suggestedPrompts, chipStyle = 'primary', }) => {
    if (!suggestedPrompts) {
        return null;
    }
    // Determine type based on chipStyle: primary = suggested, secondary = persistent
    const type = chipStyle === 'secondary' ? 'persistent' : 'suggested';
    const sendPrompt = async (prompt) => {
        if (isLoading) {
            return;
        }
        const contentForAI = `<SuggestedPrompt type="${type}" source="shopping_assistant">
${prompt}
</SuggestedPrompt>`;
        append({
            role: 'user',
            content: contentForAI,
        });
    };
    return (_jsx(Stack, { direction: "row", useFlexGap: true, sx: { flexWrap: 'wrap', padding: 1 }, spacing: 2, children: suggestedPrompts.split(splitSeparator).map((prompt) => (_jsx(Chip, { onClick: () => sendPrompt(prompt), variant: "outlined", sx: {
                textTransform: 'none',
                borderStyle: 'none',
                height: 'auto',
                paddingX: 2,
                '& .MuiChip-label': {
                    whiteSpace: 'normal',
                    paddingTop: 1,
                    paddingBottom: 1,
                },
            }, label: prompt, className: `site-system-chip-${chipStyle}` }, prompt))) }));
};
SuggestedPrompts.defaultProps = {
    chipStyle: 'primary',
};
export default SuggestedPrompts;
//# sourceMappingURL=SuggestedPrompts.js.map